import React from "react";
import { navigate } from "gatsby";
import linkResolver from "../../utils/linkResolver";
import { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import browserStorage from "@utils/browserStorage";

const useStyles = makeStyles((theme) => ({
  formControl: {
    //margin: theme.spacing(1),
    //minWidth: 120,
  },
  select: {
    color: "white",
    fontFamily: "Avenir",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.04em",
    minWidth: "50px",
  },
  icon: {
    fill: "white",
  },
  input: {
    minHeight: "unset",
  },
  menuItem: {
    color: "#FFFFFF",
    fontFamily: "Avenir",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.04em",
  },
}));

const LanguageSwitcher = ({ activeDocMeta }) => {
  const classes = useStyles();

  const currentLang = activeDocMeta.lang;
  browserStorage.setLanguage(activeDocMeta.lang);

  const currentLangOption = (
    <MenuItem value={currentLang} className={classes.menuItem}>
      {currentLang.slice(0, 2).toUpperCase()}
    </MenuItem>
  );

  const alternateLangOptions = activeDocMeta.alternateLanguages.map(
    (altLang, index) => (
      <MenuItem
        className={classes.menuItem}
        value={altLang}
        key={`alt-lang-${index}`}
      >
        {altLang.lang.slice(0, 2).toUpperCase()}
      </MenuItem>
    )
  );

  const handleLangChange = (event) => {
    const path = window.location.pathname.toLowerCase();
    const segments = path.split("/").filter(Boolean);
  
    const isLocale = (seg) => /^[a-z]{2}-[a-z]{2}$/.test(seg);
    const cleanedSegments = isLocale(segments[0]) ? segments.slice(1) : segments;
  
    if (cleanedSegments.length === 0) {
      return navigate(linkResolver(event.target.value));
    }
  
    const pageMap = {
      whysmartwealth: "whysmartwealth",
      warumsmartwealth: "whysmartwealth",
      aboutus: "aboutus",
      uberuns: "aboutus",
      contactus: "contactus",
      kontaktiereuns: "contactus",
      privateclient: "privateclient",
      privatkunden: "privateclient",
      b2b: "b2b",
      institutionalclients: "institutionalclients",
      institutionellekunden: "institutionalclients",
      brochures: "brochures",
      products: "products",
      "3iq": "3iq",
    };
  
    let type = "";
    let blogPath = "";
  
    for (let i = 0; i < cleanedSegments.length; i++) {
      const seg = cleanedSegments[i];
  
      if (seg === "blog") {
        type = "blogpost";
        blogPath = cleanedSegments[i + 1] || "";
        break;
      }
  
      if (pageMap[seg]) {
        type = pageMap[seg];
        break;
      }
    }
  
    return navigate(
      linkResolver({
        lang: event.target.value.lang,
        type,
        blogPath,
      })
    );
  };
  
  

  return (
    <FormControl className={classes.formControl}>
      <Select
        className={classes.select}
        labelId="language-selector-label"
        id="language-selector"
        value={currentLang}
        onChange={handleLangChange}
        disableUnderline={true}
        inputProps={{
          classes: {
            icon: classes.icon,
            root: classes.input,
          },
        }}
      >
        {currentLangOption}
        {alternateLangOptions}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;
